import React from 'react';
import { CheckIcon, HandshakeIcon } from 'lucide-react';
interface TogetherPanelProps {
  intro: string;
  points: string[];
}
export function TogetherPanel({
  intro,
  points
}: TogetherPanelProps) {
  return <div className="rounded-xl border border-[#10b981]/25 bg-black/40 p-5 sm:p-6" data-id="element-151" data-mp="2c6skz7ir61tw">
      <div className="flex items-center gap-2.5" data-id="element-152" data-mp="2790qq6umy3mj">
        <HandshakeIcon className="h-4 w-4 text-[#10b981]" aria-hidden="true" data-id="element-153" data-mp="2787hmz87f218" />
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#10b981]" data-id="element-154" data-mp="237nixr7zfqcz">
          We handle this together
        </p>
      </div>
      <p className="mt-4 text-[15.5px] leading-relaxed text-white sm:text-base" data-id="element-155" data-mp="1t8pyp0hlaizs">{intro}</p>
      <ul className="mt-5 space-y-3" data-id="element-156" data-mp="1taj7albrjdaf">
        {points.map(point => <li key={point} className="flex gap-3" data-id="element-157" data-mp="1ob6cneenh1xa">
            <span aria-hidden="true" className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#10b981]/40 bg-[#10b981]/10 text-[#10b981]" data-id="element-158" data-mp="3nn91z59ygqiv">
              <CheckIcon className="h-3 w-3" data-id="element-159" data-mp="2ft3ftkscr9px" />
            </span>
            <span className="text-[15px] leading-relaxed text-white/90" data-id="element-160" data-mp="2kt7y9gctmeis">{point}</span>
          </li>)}
      </ul>
    </div>;
}